import { create } from 'zustand'
import { SharedSlice, createSharedSlice } from '../../../slice'
import createPayRunsSlice, { PayRunsSlice } from './pay-runs/slice'
import createEditPayRunSlice, { EditPayRunSlice } from './pay-runs/edit/slice'
import createPaySummarySlice, { PaySummarySlice } from './pay-summary/slice'

const usePayrollStore = create<
  PayRunsSlice & EditPayRunSlice & PaySummarySlice & SharedSlice
>()((...props) => ({
  ...createSharedSlice(...props),
  ...createPayRunsSlice(...props),
  ...createEditPayRunSlice(...props),
  ...createPaySummarySlice(...props),
}))

export default usePayrollStore
